import React from 'react';

const AdminStateEnergyField = ({ data, ...props }) => {
  if (!data) return <>-</>;

  if (data.currentAdminInfo) {
    return <>ATTIVO</>;
  } else {
    return <>TERMINATO</>;
  }
};

export default AdminStateEnergyField;
